import React, { FC, ButtonHTMLAttributes } from 'react'
import { CleanButton } from '@components/gassan-ui'
import styled from 'styled-components'
import { rem } from 'polished'

type DirectionProps = {
  direction: 'prev' | 'next'
}

type Props = DirectionProps & ButtonHTMLAttributes<HTMLButtonElement>

const Button = styled(CleanButton)<DirectionProps>`
  height: ${rem(50)};
  width: ${rem(50)};
  transition: all 0.2s ease-in-out;
  background: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  pointer-events: all;
  color: black;

  svg {
    height: ${rem(14)};
    width: ${rem(14)};
    transform: ${p => p.direction === 'prev' && 'rotate(180deg)'};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${p => p.theme.rolex.colors.primary};
      color: white;
    }
  }
`

const SliderNavButton: FC<Props> = ({ direction, ...rest }) => {
  return (
    <Button direction={direction} {...rest}>
      <svg viewBox="0 0 15 15" fill="currentColor">
        <path d="m5.52 0 7.91 7.5-7.91 7.5-1.95-1.95 5.83-5.55-5.83-5.55z"></path>
      </svg>
    </Button>
  )
}

export default SliderNavButton
